
const focussableElements = 'a:not([disabled]), button:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])'

function nextFocusable (offset = 1, root = document.body) {
  //add all elements we want to include in our selection
  const allFocusableElements = root.querySelectorAll(focussableElements)
  const focussable = Array.from(allFocusableElements)
    .filter.call(allFocusableElements, function (element) {
        //check for visibility while always include the current activeElement
        return element.offsetWidth > 0 || element.offsetHeight > 0 || element === document.activeElement
    })
    .sort((a, b) => a.tabIndex - b.tabIndex)

  if (!focussable.length) return root

  const index = focussable.indexOf(document.activeElement)
  if(index > -1) {
     return focussable[index + offset]
  } else {
    return focussable[offset]
  }
}

function outerHeight (el) {
  let height = el.offsetHeight
  const style = getComputedStyle(el)
  height += parseInt(style.marginTop) + parseInt(style.marginBottom)
  return height;
}

function keyBy (arr, key) {
  const obj = {}
  for (var i = 0; i < arr.length; i++) obj[arr[i][key]] = arr[i]
  return obj
}

function find (items, predicate) {
  for (var i = 0; i < items.length; i++) {
    if (predicate(items[i])) return items[i]
  }
}

function indexOfList (list, elem) {
  for (let i = 0; i < list.length; i++) {
    if (list[i] === elem) return i
  }
  return -1
}

// Element.prototype.closest polyfill
const proto = Element.prototype
if (!proto.closest) {
  if (!proto.matches) {
    Element.prototype.matches = proto.msMatchesSelector || proto.webkitMatchesSelector
  }

  Element.prototype.closest = function (s) {
    if (!document.documentElement.contains(this)) return null
    let ancestor = this
    do {
      if (ancestor.matches(s)) return ancestor
      ancestor = ancestor.parentElement
    } while (ancestor !== null)
    return null
  }
}

function goBack () {
  if (document.referrer && document.referrer !== window.location.href) {
    window.history.go(-1)
  } else if (typeof Tv2014STBJsInterface !== 'undefined') {
    Tv2014STBJsInterface.onBackPressed()
  } else {
    // trigger a force reload, so we see that it's navigating away in dev
    window.location = '/'
  }
}

module.exports = {
  keyBy, find, indexOfList,
  outerHeight, nextFocusable,
  goBack
}
